"use strict";

import Vue from "vue";
import VueI18n from "vue-i18n";

import messages from "/src/lang/en";

const loadedLanguages = ["en"]; // our default language that is preloaded
Vue.prototype.loadedLanguages = loadedLanguages;
Vue.use(VueI18n);

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: "en", // set locale
  fallbackLocale: "en",
  messages, // set locale messages
});

export default i18n;
